export default __webpack_public_path__ + "static/media/hht1_ep06_timeline_q04_b.bac066a5.png";